import { Rectangle, Texture } from 'pixi.js';
import { Random } from '../Utils/Math';

export const shuffleArray = (array) => {
    let currentIndex = array.length, temporaryValue, randomIndex;

    while (0 !== currentIndex) {
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex -= 1;

        temporaryValue = array[currentIndex];
        array[currentIndex] = array[randomIndex];
        array[randomIndex] = temporaryValue;
    }
    
    return array;
};

export const remapValue = (value: number, low1: number, high1: number, low2: number, high2: number): number => {
    return low2 + (high2 - low2) * (value - low1) / (high1 - low1);
};

export function searchParam(key: string): string {
    const query = window.location.search.substring(1);
    const params = query.split('&');
    for (var i = 0; i < params.length; i++) {
        var pair = params[i].split('=');
        if (pair[0] === key) {
            return pair[1];
        }
    }
    return '';
}

export function convertRGBA2HEXNUM(r: number, g: number, b: number, a: number = 255): number {
    const hex = '#' +
        ('0' + parseInt(r.toString(), 10).toString(16)).slice(-2) +
        ('0' + parseInt(g.toString(), 10).toString(16)).slice(-2) +
        ('0' + parseInt(b.toString(), 10).toString(16)).slice(-2);

    return parseInt(hex.replace(/^#/, '').substr(0, 6), 16);
}

export function textureToJson(texture: Texture): number[] {
    const pixels = [];

    const width = texture.baseTexture.width;
    const height = texture.baseTexture.height;

    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');

    ctx.drawImage(texture.baseTexture.source, 0, 0);

    for (let x = 0; x < width; x++) {
        for (let y = 0; y < height; y++) {
            const pixel = ctx.getImageData(x, y, 1, 1);
            const data = pixel.data;

            pixels.push([data[0], data[1], data[2]]);
        }
    }

    return pixels;
}

export function sampleFromArray(array: any, from: number = 0): any {
    return array[from + Math.round(Random() * (array.length - from-1))];
}

export function hitTest(a: Rectangle, b: Rectangle): boolean {
    const rA = a.x + a.width;
    const rB = b.x + b.width;
    const bA = a.y + a.height;
    const bB = b.y + b.height;

    const hitX = rA > b.x && a.x < rB;
    const hitY = bA > b.y && a.y < bB;

    return hitX && hitY;
}
